import React, {useState} from 'react';

import Header from '../header/header'

import layoutStyles from './layout.module.scss'
import sidebarStyles from '../sidebar/sidebar.module.scss'

import '../../styles/index.scss'



function Layout(props) {

    const [isSidebarOpen, setSidebar] = useState(false);

    return (
        <div className={layoutStyles.container}>
            <Header location={props.location}/>
            <div className={layoutStyles.content}>
                {props.children}
            </div>
            <div onClick={() => {
                let sidebar = document.getElementById('sidebar');
                sidebar.style.display = isSidebarOpen ? 'none' : 'block';
                setSidebar(!isSidebarOpen)
            }}
                 className={isSidebarOpen ? sidebarStyles.sidebarVisibleControlBtn : sidebarStyles.sidebarHiddenControlBtn}>
            </div>


        </div>
    )
}

export default Layout